<template>
	<div>
		<v-bottom-sheet v-model="sheet">
			<v-list class="pb-0">
				<v-list-item @click="launchFilePicker('camera')">
					<v-list-item-avatar>
						<v-avatar size="32px" item>
							<v-icon>camera</v-icon>
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-title>CAMERA</v-list-item-title>
				</v-list-item>
				<v-list-item @click="launchFilePicker('library')">
					<v-list-item-avatar>
						<v-avatar size="32px" item>
							<v-icon>image</v-icon>
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-title>GALLERIA</v-list-item-title>
				</v-list-item>
				<v-divider></v-divider>
				<v-list-item class="red white--text" @click="sheet = false">
					<v-list-item-avatar>
						<v-avatar size="32px" item>
							<v-icon color="white">close</v-icon>
						</v-avatar>
					</v-list-item-avatar>
				<v-list-item-title>CHIUDI</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-bottom-sheet>

	<!-- slot for parent component to activate the file changer -->
	<div @click="clickAvatar">
		<slot name="activator" :preview="preview"></slot>
	<!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
		<input type="file"
		accept="image/*"
		capture
		ref="file"
		@input="previewImage"
		style="display:none">
	</div>

	<!-- error dialog displays any potential error messages -->
	<v-dialog v-model="errorDialog" max-width="300">
		<v-card>
			<v-card-text class="subheading">{{errorText}}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="errorDialog = false" text>OK</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<div id="canvas"></div>

</div>
</template>

<script>
import { CameraService, PlatformService } from '@/services/native'

export default {
	name: 'image-input',
	data() {
		return {
			errorDialog: null,
			errorText: '',
			sheet: false,
			preview: null,
			image: null,
		}
	},

	props: {
		value: File,
	},

	methods: {
		previewImage() {
			const input = this.$refs.file
			const files = input.files
			if (files && files[0]) {
				const reader = new FileReader
				reader.onload = e => {
					this.preview = e.target.result
				}
				reader.readAsDataURL(files[0])
				this.$emit('input', files[0])
			}
		},

		clickAvatar() {
			if (PlatformService.isNative()) {
				this.sheet = true
			} else {
				this.$refs.file.click()
			}
		},

		async launchFilePicker(source) {
			this.sheet = false

			try {
				const dataUrl = await CameraService.getPhoto({
					quality: 20,
					source: source,
					allowEdit: true
				})

				if (dataUrl) {
					this.processDataURL(dataUrl)
				}
			} catch (error) {
				this.errorText = error.message || 'Errore fotocamera'
				this.errorDialog = true
			}
		},

		processDataURL(dataUrl) {
			this.preview = dataUrl
			const file = this.dataURLtoFile(dataUrl, 'photo_' + Date.now() + '.jpg')
			this.$emit('input', file)
		},

		dataURLtoFile(dataUrl, filename) {
			const arr = dataUrl.split(',')
			const mimeMatch = arr[0].match(/:(.*?);/)
			const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg'
			const bstr = atob(arr[1])
			let n = bstr.length
			const u8arr = new Uint8Array(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new File([u8arr], filename, { type: mime })
		},
	}
}
</script>